<div id="user-data-container">
  <section>
    <nes-heading tag="h1" size="6xl" [cypress]="'page_title'" class="page-heading">
      @if ((cardOrdinal$ | async) === 1) {
        {{ "USER_DATA.TITLE" | translate }}
      } @else {
        {{ "USER_DATA.TITLE_NTH" | translate: { n: (cardOrdinal$ | async) } }}
      }
    </nes-heading>
    <nes-text class="intro-text">{{ "USER_DATA.SUB_TEXT" | translate }}</nes-text>
  </section>
  <ng-container *ngIf="selectedProduct$ | async as selectedProduct">
    <section *ngIf="(totalProductCount$ | async) > 1" class="mb-3">
      <nes-heading
        tag="h2"
        size="4xl"
        class="headingS"
        [cypress]="'product_title'"
      >
        <strong>{{
          "COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS." +
            selectedProduct.identifier +
            ".TITLE" | translate
        }}</strong>
      </nes-heading>
      <div *ngIf="selectedProduct.route as route">
        {{ route.from.naam }} - {{ route.to.naam }}
      </div>
      <nes-text>
        {{ selectedProduct | displayServices | async }}
      </nes-text>
    </section>
    <section class="animated fadeIn">
      <form
        [formGroup]="formGroup"
        (focusin)="onFirstInteraction($event)"
        id="user_data_name"
        name="user_data_name"
      >
        <div class="user-data-form-fields">
        <div class="formfield">
          <nes-text class="nes-mb-2 form-label-strong" weight="bold" color="blue" size="md">
            {{ "INPUT.GENDER.LABEL" | translate }}
          </nes-text>

          <ul [cypress]="'gender'" class="list formfield__inputGroup">
            <li
              *ngFor="let gender of genders"
              class="list__item formfield__inputGroupItem"
            >
              <div class="radioButton">
                <input
                  [id]="'gender_' + gender.value"
                  [formControl]="getControl('gender')"
                  [value]="gender.value"
                  [cypress]="gender.value"
                  type="radio"
                  class="radioButton__input"
                  name="gender"
                  privacySensitive
                />
                <label
                  class="radioButton__label"
                  [for]="'gender_' + gender.value"
                  tabindex="-1"
                >
                  {{ gender.displayText | translate }}
                </label>
              </div>
            </li>
          </ul>
          @if (getGenderErrorKey() !== undefined) {
            <nes-error-message>
              {{ getGenderErrorKey() }}
            </nes-error-message>
          }
        </div>

        <div class="nes-grid nes-grid-cols-2 nes-gap-x-5 initials-middlename-row">
          <div class="formfield">
            <nes-input
              [label]="'INPUT.INITIALS.LABEL' | translate"
              [name]="'INPUT.INITIALS.NAME' | translate"
              [placeholder]="'INPUT.INITIALS.PLACEHOLDER' | translate"
              [value]="formGroup.get('initials')!.value"
              [formControl]="getControl('initials')"
              formControlName="initials"
              required
              (nesOnKeyDown)="_uiService.isOnlyLettersInInitials($event)"
              [cypress]="'initials'"
              nes-id="initials"
              id="initials"
              maxLength="10"
              nesFormControl
              receiptFooterVisibility
              formatInitials
              formatInitialsIE
              privacySensitive
              controlled
              type="text"
            ></nes-input>
            @if (getInitialsErrorKey() !== undefined) {
              <nes-error-message>
                {{ getInitialsErrorKey() }}
              </nes-error-message>
            }
          </div>

          <bca-middle-name
            [userForm]="formGroup"
            [middleNames]="middleNames$ | async"
          >
          </bca-middle-name>
        </div>

        <div class="formfield">
          <nes-input
            [label]="'INPUT.LASTNAME.LABEL' | translate"
            [name]="'INPUT.LASTNAME.NAME' | translate"
            [placeholder]="'INPUT.LASTNAME.PLACEHOLDER' | translate"
            [value]="formGroup.get('lastName')!.value"
            formControlName="lastName"
            [formControl]="getControl('lastName')"
            nesFormControl
            controlled
            [cypress]="'last_name'"
            required
            receiptFooterVisibility
            privacySensitive
            maxLength="40"
            [forceUppercase]="{ firstLetterOnly: true }"
            nes-id="last_name"
            type="text"
            (nesOnKeyDown)="_uiService.isIgnoreNumbersInLastName($event)"
          ></nes-input>
          @if (getLastNameErrorKey() !== undefined) {
            <nes-error-message>
              {{ getLastNameErrorKey() }}
            </nes-error-message>
          }
        </div>

        <bca-choose-birth-date
          [selectedDate]="(selectedBirthDate$ | async)?.dateString"
          [dateRequiredError]="hasError('birthDate', 'required')"
          [dateValidError]="hasError('birthDate', 'dateValidator')"
          [dateAgeError]="hasError('birthDate', 'ageValidator')"
          [forceTouched]="showValidationError"
          (dateStringSelected)="selectedABirthdate($event)"
          (dateSelected)="onBirthDateSelected($event)"
        >
        </bca-choose-birth-date>

        <div class="formfield">
          <nes-input
            [label]="'INPUT.EMAIL.LABEL' | translate"
            [name]="'INPUT.EMAIL.NAME' | translate"
            [placeholder]="'INPUT.EMAIL.PLACEHOLDER' | translate"
            [value]="formGroup.get('email')!.value"
            formControlName="email"
            [formControl]="getControl('email')"
            nesFormControl
            controlled
            [cypress]="'email'"
            receiptFooterVisibility
            privacySensitive
            forceLowercase
            noSpace
            required
            maxLength="50"
            nes-id="email"
            type="email"
          ></nes-input>
          @if (getEmailErrorKey() !== undefined) {
            <nes-error-message>
              {{ getEmailErrorKey() }}
            </nes-error-message>
          }
        </div>

        <bca-choose-country
          [userForm]="formGroup"
          [selectedCountryCode]="selectedCountryCode$ | async"
          [countries]="countries$ | async"
          (selected)="onCountrySelected($event, selectedProduct)"
        >
        </bca-choose-country>

        <bca-user-address
          [addressForm]="getControl('address')"
          [postcodeLength]="(selectedCountrySettings$ | async)?.postcodeLength"
          [searchableAddress]="
            (selectedCountrySettings$ | async)?.searchableAddress
          "
          [searchFailed]="addressSearchFailed$ | async"
          [addressLoading]="addressLoading$ | async"
          [manualMode]="addressManualMode$ | async"
          (search)="onAddressSearch($event)"
          (manual)="onAddressManual(selectedProduct, $event)"
          [isMobileView]="mobileQueryMatches$ | async"
        >
        </bca-user-address>

        <ng-container *ngIf="selectedProduct.needsPhoto">
          <bca-choose-image
            [imageRequiredError]="
              isTouchedAndDirty('image') && hasError('image', 'required')
            "
            [selectedFaceImage]="selectedFaceImage$ | async"
            (openDialog)="onImageDialogOpened()"
            (delete)="onImageDelete()"
          >
          </bca-choose-image>
        </ng-container>

        <bca-use-product
          [selectedProductUsage]="(selectedUseProduct$ | async)?.type"
          [selectedProductUsageDate]="(selectedUseProduct$ | async)?.date"
          (dateSelected)="onProductUsageDateSelected($event)"
          (selected)="onProductUsageSelected($event)"
        >
        </bca-use-product>


        </div><!-- end user-data-form-fields -->

        @if (showValidationError && !formGroup.valid) {
          <div class="user-data-validation-error">
            <div class="user-data-validation-error__left-bar"></div>
            <div class="user-data-validation-error__content">
              <div class="user-data-validation-error__title">
                <nes-icon name="alert-thick-filled" class="user-data-validation-error__icon"></nes-icon>
                Niet alles is ingevuld
              </div>
              <div class="user-data-validation-error__subtitle">
                Vul de gegevens die missen in om verder te gaan.
              </div>
            </div>
          </div>
        }

        <div
          class="nes-flex nes-justify-start nes-items-center nes-flex-wrap continue-button-row"
        >
          <nes-button
            nes-id="to_company_page"
            id="to_company_page"
            variant="primary"
            [cypress]="'next_page'"
            type="button"
            (nesOnClick)="formSubmit()"
          >
            {{ "USER_DATA.BUTTON.CONTINUE" | translate }}
          </nes-button>
        </div>
      </form>
    </section>
  </ng-container>
</div>

<ng-container *ngIf="(cartProducts$ | async)?.length > 0">
  <div class="mobile-cart lg:nes-hidden nes-mt-4">
    <aside class="order-cart">
      <h3 class="cart-title">
        <span class="cart-title__line1">{{ 'VERIFY.CART.TITLE' | translate }}</span>
        <span class="cart-title__line2">{{ confirmedProductCount$ | async }} NS-Business Card{{ (confirmedProductCount$ | async) > 1 ? 's' : '' }}</span>
      </h3>

      <ng-container *ngFor="let product of cartProducts$ | async">
        <div class="cart-product-box">
          <div class="cart-row cart-row--name" *ngIf="product.user">
            <span>{{ product.user | displayName | async }}</span>
          </div>
          <div class="cart-row">
            <span>{{ 'COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS.' + product.identifier + '.TITLE' | translate }}</span>
            <span>€ {{ product.price | priceFormat }}</span>
          </div>
          <ng-container *ngFor="let addon of product.addons">
            <div *ngIf="addon.identifier === 'BFA' && addon.selected" class="cart-row">
              <span>{{ 'VERIFY.IC_DIRECT_TITLE' | translate }}</span>
              <span>€ {{ addon.price | priceFormat }}</span>
            </div>
            <div *ngIf="addon.identifier.includes('_UPDATE') && addon.selected" class="cart-row">
              <span>{{ 'VERIFY.ADDON.' + addon.identifier + '.TITLE' | translate }}</span>
              <span *ngIf="addon.price">€ {{ addon.price | priceFormat }}</span>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <div class="cart-subtotals">
        <div class="cart-row">
          <span>{{ 'VERIFY.SUBTOTAL' | translate }}</span>
          <span>€ {{ cartSubTotalReceiptPrice$ | async | priceFormat }}</span>
        </div>
        <div class="cart-row">
          <span>{{ 'VERIFY.TAX_PRICE' | translate }}</span>
          <span>€ {{ cartTax$ | async | priceFormat }}</span>
        </div>
      </div>

      <hr class="cart-separator" />

      <div class="cart-total-row">
        <span>{{ 'FREQUENTION.MONTH_TOTAL' | translate }}</span>
        <span>€ {{ cartTotalReceiptPrice$ | async | priceFormat }}</span>
      </div>

      <nes-button
        [cypress]="'next_page_mobile'"
        variant="secondary"
        type="button"
        (nesOnClick)="formSubmit()"
      >
        {{ 'VERIFY.BUTTON.EDIT_ORDER' | translate }}
      </nes-button>
    </aside>
  </div>
  <nes-divider class="nes-mt-4"></nes-divider>
</ng-container>
